import React from 'react';
import ColorPicker from './ColorPicker.js';
import FroalaEditor from 'react-froala-wysiwyg';
import FileUploader from "react-firebase-file-uploader";

// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'
import $ from 'jquery';
const { firebase } = window;

const availableFontSizes = [10,12,14,16,18,20,22,25,28,32,36,40];
const availableBoardPatterns = {
    'hu' : ['nincs', 'csíkos', 'pontozott', 'lépcsős', 'piramis', 'fa hatású', 'fa hatású 2', 'papír', 'textil', 'fém'],
    'en' : ['no', 'striped', 'dotted', 'Stairs', 'Pyramid', 'Wooden', 'Wooden2', 'Paper', 'Textile', 'Metal']
};

const availableBoardSizes = [2, 4, 6, 8, 10, 12, 16, 20, 24];
var activeEditorEl;
var editors = [];

export default class Settings extends React.Component {
    constructor() {
        super();

        this.loadEditorCustomButtons();
    }
    
    render() {
        var froalaFontFamily = {};
        for (var font in this.props.availableFontFamilys) {
            froalaFontFamily[this.props.availableFontFamilys[font].family] = font;
        }
        const froalaConfig = {
            fontFamily: froalaFontFamily,
            fontSizeDefaultSelection: '24',
            iconsTemplate: 'font_awesome_5',
//            imageUploadURL: 'http://localhost:3006/image_upload',
            imageUploadURL: 'https://us-central1-bajnok-app.cloudfunctions.net/app/image_upload',
            key: 'hD2B1E2J2C6C1D-17D2E2F2B1E4G1A3B8D7A6nrdeB1tpB-13ihyywkosE5f1kh==',
            imageUploadParams: {
                id: 'my_editor'
            },
            charCounterCount: false,
            multiLine: true,
            events: {
                'froalaEditor.image.beforeUpload' : (e, editor, images) => {
                    this.uploadImage = images[0];
                },
                'froalaEditor.image.uploaded': (e, editor, response) => {
                    var storageRef = firebase.storage().ref("figures").child(this.uploadImage.name);
                    storageRef.put(this.uploadImage).then((snapshot) => {
                        snapshot.ref.getDownloadURL().then((downloadURL) => {
                          this.downloadURL = downloadURL;
                          editor.image.insert(this.downloadURL, null, null, editor.image.get());
                        });
                    });
                    return false;
                },
                'froalaEditor.focus': (e, editor) => {
                    // TODO ez nem kell ide?
                    activeEditorEl = editor;
                    //console.log(activeEditorEl);
                    //editor.toolbar.show();
                },
                'froalaEditor.blur': (e, editor) => {
                    //editor.toolbar.hide();
                },
                'froalaEditor.initialized': (e, editor) => {
                    editors.push(editor);
                    //editor.toolbar.hide();
                    //this.hideLicense();
                },
                'froalaEditor.contentChanged': (e, editor) => {
                    //this.hideLicense();
                },
            },
            placeholderText: '',
            pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'embedly', 'emoticons', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image', 'imageManager', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'quickInsert', 'quote', 'save', 'table', 'url', 'video', 'wordPaste'],
//            shortcutsEnabled: ['show', 'bold', 'italic', 'underline', 'strikeThrough', 'indent', 'outdent', 'insertImage', 'createLink'],
            toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', '|', 'position_number', 'starting_color', 'difficulty'],
            toolbarButtonsMD: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', '|', 'position_number', 'starting_color', 'difficulty'],
            toolbarButtonsSM: ['bold', 'italic', 'underline', 'strikeThrough', '|', 'fontFamily', 'fontSize', 'color', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '|', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'spellChecker', 'help', 'html', '|', 'undo', 'redo', '|', 'position_number', 'starting_color', 'difficulty'],
            toolbarButtonsXS: ['bold', 'italic', 'underline', '|', 'fontFamily', 'fontSize', 'color', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertVideo', 'insertFile', 'insertTable', '|', 'insertHR', 'selectAll', 'clearFormatting', '|', 'spellChecker', '|', 'undo', 'redo', '|', 'position_number', 'starting_color', 'difficulty'],
        }
        
        return (
        !this.props.showSettings
            ? (
                <div className="settings_toggle">
                    <img alt={this.props.strings.settings} title={this.props.strings.settings} onClick={this.props.toggleSettings.bind(this)} src="/chessboardjs/img/icons/menu-icon.svg" />
                </div>
            )
            : (
        <form>
        <fieldset>
            <div className="settings_toggle">
                <img alt={this.props.strings.settings} title={this.props.strings.settings} onClick={this.props.toggleSettings.bind(this)} src="/chessboardjs/img/icons/menu-icon.svg" />
            </div>
            <Tabs defaultIndex={this.props.defaultTab} onSelect={index => this.props.updateState('defaultTab', index)}>
                <TabList>
                    <Tab>{this.props.strings.theme}</Tab>
                    <Tab>{this.props.strings.position}</Tab>
                    <Tab>{this.props.strings.extras}</Tab>
                </TabList>
                <TabPanel>
                    <label>{this.props.strings.piece}</label>
                    <div className="container" style={{padding: '0px'}}>
                        <div className="row">
                            <div className="column">
                                {this.props.strings.theme}
                                <select id="pieceThemeField" value={this.props.board.pieceTheme} onChange={this.updateSetting.bind(this, 'board', 'pieceTheme')}>
                                {Object.keys(this.props.availablePieceThemes).map(theme => <option key={theme} value={theme}>{this.props.availablePieceThemes[theme].name}</option>)}
                                </select>
                            </div>
                            <div className="column">
                                {this.props.strings.pieceSize}
                                <select id="pieceSizeField" value={this.props.board.pieceSize} onChange={this.updateSetting.bind(this, 'board', 'pieceSize')}>
                                    <option value="100">100%</option>
                                    <option value="90">90%</option>
                                    <option value="80">80%</option>
                                    <option value="75">75%</option>
                                    <option value="70">70%</option>
                                    <option value="full">{this.props.strings.fullSize}</option>                                
                                </select>
                            </div>
                            <div className="column">
                                {this.props.strings.uniquePieceSize}
                                <Slider
                                    min={0}
                                    max={10}
                                    step={1}
                                    value={this.props.board.extraPieceSize}
                                    orientation="horizontal"
                                    onChange={this.updateSettingWithValue.bind(this, 'board', 'extraPieceSize')}
                                />
                            </div>
                        </div>
                    </div>
                    
                    <label>{this.props.strings.table}</label>
                    <div className="container" style={{padding: '0px'}}>
                        <div className="row">
                            <div className="column column-20">
                                {this.props.strings.white}
                                <ColorPicker
                                    color={{hex: this.props.board.boardColors.white}}
                                    handleChange={this.handleBoardColorChange.bind(this, 'white')}
                                />
                            </div>
                            <div className="column column-20">
                                {this.props.strings.black}
                                <ColorPicker
                                    color={{hex: this.props.board.boardColors.black}}
                                    handleChange={this.handleBoardColorChange.bind(this, 'black')}
                                />
                            </div>
                            <div className="column">
                                {this.props.strings.theme}
                                <select id="boardThemeField" value={this.props.board.boardTheme} onChange={this.updateBoardTheme.bind(this)}>
                                {Object.keys(this.props.availableBoardThemes).map(theme => <option key={theme} value={theme}>{theme}</option>)}
                                </select>
                            </div>
                            <div className="column">
                                {this.props.strings.pattern}
                                <select id="boardPatternField" value={this.props.board.boardPattern} onChange={this.updateSetting.bind(this, 'board', 'boardPattern')}>
                                {availableBoardPatterns[this.props.lang].map((pattern, index) => <option key={pattern} value={availableBoardPatterns.en[index]}>{pattern}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="column column-25">
                                {this.props.strings.size}
                                <select id="boardSize" value={this.props.board.boardSize} onChange={this.updateSetting.bind(this, 'board', 'boardSize')}>
                                {availableBoardSizes.map(size => <option key={size} value={size}>{size}x{size}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <label>{this.props.strings.coordinates}</label>
                    <div className="container" style={{padding: '0px'}}>
                        <div className="row">
                            <div className="column column-20">
                                <div style={{float: 'left'}}>
                                <ColorPicker
                                    color={{hex: this.props.notation.color}}
                                    handleChange={this.handleColorChange.bind(this, 'notation', 'color')}
                                />
                                </div>
                            </div>
                            <div className="column column-25">
                                <select
                                    value={this.props.notation.type}
                                    onChange={this.updateSetting.bind(this, 'notation', 'type')}>
                                    <option value="small">{this.props.strings.smallLetters}</option>
                                    <option value="capital">{this.props.strings.capitalLetters}</option>
                                    <option value="black">{this.props.strings.blackImages}</option>
                                    <option value="color">{this.props.strings.colorImages}</option>
                                    <option value="none">{this.props.strings.hide}</option>
                                </select>
                            </div>
                            <div className="column column-30">
                                <select
                                    value={this.props.notation.fontFamily}
                                    onChange={this.updateSetting.bind(this, 'notation', 'fontFamily')}>
                                    {Object.keys(this.props.availableFontFamilys).map((font) => <option key={font} value={font} style={{fontFamily: this.props.availableFontFamilys[font].family}}>{font}</option>)}
                                </select>
                            </div>
                            <div className="column column-20">
                                <select
                                    style={{width: '60px'}}
                                    value={this.props.notation.fontSize}
                                    onChange={this.updateSetting.bind(this, 'notation', 'fontSize')}>
                                {availableFontSizes.map(fontSize => <option key={fontSize} value={fontSize}>{fontSize}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>
                    <table className="themeSaving"><tbody>
                    <tr>
                        <td><img alt={this.props.strings.saveTheme} title={this.props.strings.saveTheme} onClick={this.props.toggleModal.bind(this, 'save_theme')} src="/chessboardjs/img/icons/save-theme.svg" /></td>
                        <td><img alt={this.props.strings.loadTheme} title={this.props.strings.loadTheme} onClick={this.props.toggleModal.bind(this, 'load_theme')} src="/chessboardjs/img/icons/load-theme.svg" /></td>
                    </tr>
                    </tbody></table>
                        
                </TabPanel>
                <TabPanel>
                    <label htmlFor="headlineField">{this.props.strings.headline}</label>
                    <div id="headlineField">
                    <FroalaEditor
                        config={froalaConfig}
                        model={this.props.headline.text}
                        onModelChange={this.updateSettingWithValue.bind(this, 'headline', 'text')}
                        tag='textarea'
                    />
                    </div>

                    <label htmlFor="descriptionField">{this.props.strings.description}</label>
                    <div id="descriptionField">
                    <FroalaEditor
                        config={froalaConfig}
                        model={this.props.description.text}
                        onModelChange={this.updateSettingWithValue.bind(this, 'description', 'text')}
                        tag='textarea'
                    />
                    </div>

                    <div style={{height: '100px'}}>
                        <a href="" onClick={this.toggleWhoCanWin.bind(this)}>
                            <img alt={this.props.strings.whoCanWin} title={this.props.strings.whoCanWin} src={this.props.whoCanWinStates[this.props.whoCanWin].icon} style={{width: '40px'}} />
                        </a>
                        <a href="" onClick={this.toggleGamification.bind(this)}>
                            <img alt={this.props.strings.toggleFigure} title={this.props.strings.toggleFigure} src="/chessboardjs/img/sword-icon.png" style={{width: '34px'}} />
                        </a>
                        <a href="" onClick={this.resetPositionSettings.bind(this)}>
                            <img alt={this.props.strings.resetPositionSettings} title={this.props.strings.resetPositionSettings} src="/chessboardjs/img/icons/reset.png" style={{width: '34px'}} />
                        </a>

                        <div className="container" style={{padding: '0px'}}>
                            <div className="row">
                                <div className="column" style={{paddingRight: 0}}>
                                    <select id="difficultyField" value={this.props.difficulty} onChange={this.updateRootSetting.bind(this, 'difficulty')}>
                                        <option value="easy">{this.props.strings.easy}</option>
                                        <option value="hard">{this.props.strings.hard}</option>
                                        <option value="none">{this.props.strings.hide}</option>
                                        <option value="custom">{this.props.strings.custom}</option>
                                    </select>
                                </div>
                                <div className="column" style={{width: '60px'}}>
                                    <label style={{backgroundColor: 'steelblue', color: 'white', padding: '5px 0px', textAlign: 'center', borderRadius: 4, cursor: 'pointer', display: this.props.difficulty !== 'custom'?'none':'block'}}>
                                    +
                                        <FileUploader
                                        hidden
                                        accept="image/*"
                                        name="difficulty_icon"
                                        randomizeFilename
                                        storageRef={firebase.storage().ref("difficulty")}
                                        onUploadError={this.handleUploadError}
                                        onUploadSuccess={this.handleUploadSuccess}
                                        maxWidth="50"
                                        maxHeight="50"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="column column-40">
                                    {this.props.strings.positionNumber}:
                                </div>
                                <div className="column column-25">
                                    <input type="text" value={this.props.currentPage} onChange={this.updateRootSetting.bind(this, 'currentPage')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="column" style={{paddingRight: 0, width: '180px'}}>
                                    <input type="button" className="button" id="exportFen" onClick={this.props.exportFen.bind(this)} value={this.props.strings.fenExport} />
                                </div>
                                <div className="column" style={{paddingRight: 0, width: '180px'}}>
                                    <input type="button" className="button" id="importFen" onClick={this.props.toggleModal.bind(this, 'import_fen')} value={this.props.strings.fenImport} />
                                </div>
                            </div>                            
                        </div>

                    </div>                    
                </TabPanel>
                <TabPanel>
                    <Tabs defaultIndex={this.props.defaultTabExtra} onSelect={index => this.props.updateState('defaultTabExtra', index)}>
                        <TabList>
                            <Tab>{this.props.strings.highlights}</Tab>
                            <Tab>{this.props.strings.arrows}</Tab>
                            <Tab>{this.props.strings.walls}</Tab>
                            <Tab>{this.props.strings.layers}</Tab>
                            <Tab>{this.props.strings.indexes}</Tab>
                        </TabList>
                        <TabPanel>
                            <label>{this.props.strings.highlight} 1</label>
                            {this.highlightSetting('highlight1')}
                            <label>{this.props.strings.highlight} 2</label>
                            {this.highlightSetting('highlight2')}
                            <label>{this.props.strings.highlight} 3</label>
                            {this.highlightSetting('highlight3')}
                        </TabPanel>
                        <TabPanel>
                            <label>{this.props.strings.arrow} 1</label>
                            {this.arrowSetting('arrow1')}
                            <label>{this.props.strings.arrow} 2</label>
                            {this.arrowSetting('arrow2')}
                            <label>{this.props.strings.arrow} 3</label>
                            {this.arrowSetting('arrow3')}
                        </TabPanel>
                        <TabPanel>
                            <label>{this.props.strings.wall} 1</label>
                            {this.wallSetting('wall1')}
                            <label>{this.props.strings.wall} 2</label>
                            {this.wallSetting('wall2')}
                            <label>{this.props.strings.wall} 3</label>
                            {this.wallSetting('wall3')}
                        </TabPanel>
                        <TabPanel>
                            <label>{this.props.strings.layer} 1</label>
                            {this.layerSetting('layer1')}
                            <label>{this.props.strings.layer} 2</label>
                            {this.layerSetting('layer2')}
                            <label>{this.props.strings.layer} 3</label>
                            {this.layerSetting('layer3')}
                        </TabPanel>
                        <TabPanel>
                            <label>{this.props.strings.index} 1</label>
                            {this.indexSetting('index1')}
                            <label>{this.props.strings.index} 2</label>
                            {this.indexSetting('index2')}
                            <label>{this.props.strings.index} 3</label>
                            {this.indexSetting('index3')}
                        </TabPanel>
                    </Tabs>
                </TabPanel>
            </Tabs>
        </fieldset>
        </form>
            )
        )        
    }

    loadEditorCustomButtons() {
        $.FroalaEditor.DefineIcon('position_number', {NAME: 'position-number', SRC: '/chessboardjs/img/hashtag-solid.svg', ALT: 'Insert pos', template: 'image'});
        $.FroalaEditor.RegisterCommand('position_number', {
            title: 'Insert position',
            focus: true,
            undo: true,
            refreshAfterCallback: false,
            callback: () => {
                activeEditorEl.html.insert('#P', true);
                activeEditorEl.undo.saveStep();
            },
        });

        $.FroalaEditor.DefineIcon('starting_color', {NAME: 'starting-color', SRC: '/chessboardjs/img/next_move.png', ALT: 'Next to move', template: 'image'});
        $.FroalaEditor.RegisterCommand('starting_color', {
            title: 'Next to move',
            focus: true,
            undo: true,
            refreshAfterCallback: false,
            callback: () => {
                activeEditorEl.html.insert('#W', true);
                activeEditorEl.undo.saveStep();
            },
        });

        $.FroalaEditor.DefineIcon('difficulty', {NAME: 'difficulty', SRC: '/chessboardjs/img/question_icon.svg', ALT: 'Difficulty', template: 'image'});
        $.FroalaEditor.RegisterCommand('difficulty', {
            title: 'Difficulty',
            focus: true,
            undo: true,
            refreshAfterCallback: false,
            callback: () => {
                activeEditorEl.html.insert('#D', true);
                activeEditorEl.undo.saveStep();
            },
        });
    }

    updateBoardTheme(event) {
        var board = this.props.board;
        board.boardTheme = event.target.value;
        board.boardColors = this.props.availableBoardThemes[board.boardTheme];
        this.props.updateState('board', board);
    }

    updateSetting(type, id, event) {
        var state = this.props[type];
        state[id] = event.target.value;
        this.props.updateState(type, state);
    }
    updateMultiLevelSetting(type, version, id, event) {
        var state = this.props[type];
        state[version][id] = event.target.value;
        this.props.updateState(type, state);
    }

    updateSettingWithValue(type, id, value) {
        var state = this.props[type];
        state[id] = value;
        this.props.updateState(type, state);
    }
    updateMultiLevelSettingWithValue(type, version, id, value, event) {
        var state = this.props[type];
        state[version][id] = value;
        this.props.updateState(type, state);
    }

    updateRootSetting(type, event) {
        this.props.updateState(type, event.target.value);
    }

    handleColorChange(type, field, color) {
        var state = this.props[type];
        state[field] = color.hex;
        this.props.updateState(type, state);
    }
    handleMultiLevelColorChange(type, version, field, color) {
        var state = this.props[type];
        state[version][field] = color.hex;
        this.props.updateState(type, state);
    }

    handleBoardColorChange(type, color) {
        var board = this.props.board;
        board.boardTheme = 'custom';
        board.boardColors[type] = color.hex;
        this.props.updateState('board', board);
    }

    toggleWhoCanWin(event) {
        event.preventDefault();
        var whoCanWin = (this.props.whoCanWin + 1) % 4;
        this.props.updateState('whoCanWin', whoCanWin);
    }

    toggleGamification(event) {
        event.preventDefault();
        var gamification = (this.props.description.gamification + 1) % this.props.gamificationStates.length;
        this.updateSettingWithValue('description', 'gamification', gamification);
    }
    resetPositionSettings(event) {
        event.preventDefault();
        editors[0].html.set(this.props.defaultHeadlineText);
        editors[0].undo.saveStep();

        editors[1].html.set('');
        editors[1].undo.saveStep();

        this.props.updateState('description', {text: "", gamification: false});
    }

    hideLicense() {
        var license1 = document.querySelector('#headlineField div.fr-wrapper div[style*="z-index: 9999"]');
        if (license1) {
            license1.style.display = 'none';
        }
        var license2 = document.querySelector('#descriptionField div.fr-wrapper div[style*="z-index: 9999"]');
        if (license2) {
            license2.style.display = 'none';
        }
        // Bugos volt, időnként elhalt az editor miatta
        /*var license1 = $('#headlineField .fr-wrapper').children().first();
        var license2 = $('#descriptionField .fr-wrapper').children().first();
        if (license1.css('z-index') === '9999') {
            license1.css('display','none');
            license2.css('display','none');
            $('headline .fr-wrapper .fr-placeholder').css('margin-top', '0');
            $('description .fr-wrapper .fr-placeholder').css('margin-top', '0');
        }*/
    }

    handleUploadError = error => {
        console.error(error);
    }
    handleUploadSuccess = (filename) => {
        firebase
          .storage()
          .ref("difficulty")
          .child(filename)
          .getDownloadURL()
          .then(url => {
            this.props.updateState('customDifficulty', url);
          });
    }

    highlightSetting(version) {
        return (
            <div className="container" style={{padding: '0px'}}>
                <div className="row">
                    <div className="column column-20">
                        {this.props.strings.color}
                        <ColorPicker
                            color={{hex: this.props.highlightStyle[version].color}}
                            handleChange={this.handleMultiLevelColorChange.bind(this, 'highlightStyle', version, 'color')}
                        />
                    </div>                
                    <div className="column">
                        {this.props.strings.type}
                        <select value={this.props.highlightStyle[version].type} onChange={this.updateMultiLevelSetting.bind(this, 'highlightStyle', version, 'type')}>
                            <option value="square">{this.props.strings.square}</option>
                            <option value="circle">{this.props.strings.circle}</option>
                        </select>
                    </div>
                    <div className="column">
                        {this.props.strings.size}
                        <Slider
                            min={0}
                            max={10}
                            step={1}
                            value={this.props.highlightStyle[version].size}
                            orientation="horizontal"
                            onChange={this.updateMultiLevelSettingWithValue.bind(this, 'highlightStyle', version, 'size')}
                        />
                    </div>
                    <div className="column">
                        {this.props.strings.radius}
                        <Slider
                            min={0}
                            max={10}
                            step={1}
                            value={this.props.highlightStyle[version].radius}
                            orientation="horizontal"
                            onChange={this.updateMultiLevelSettingWithValue.bind(this, 'highlightStyle', version, 'radius')}
                        />
                    </div>
                </div>
            </div>            
        )
    }

    arrowSetting(version) {
        return (
        <div className="container" style={{padding: '0px'}}>
            <div className="row">
                <div className="column column-25">
                    {this.props.strings.type}
                    <select value={this.props.arrowStyle[version].type} onChange={this.updateMultiLevelSetting.bind(this, 'arrowStyle', version, 'type')}>
                        <option value="normal">{this.props.strings.normal}</option>
                        <option value="horse">{this.props.strings.horse}</option>
                        <option value="curved-top">{this.props.strings.curvedTop}</option>
                        <option value="curved-bottom">{this.props.strings.curvedBottom}</option>
                        <option value="curved-left">{this.props.strings.curvedLeft}</option>
                        <option value="curved-right">{this.props.strings.curvedRight}</option>
                    </select>
                </div>
                <div className="column column-25">
                    {this.props.strings.location}
                    <select value={this.props.arrowStyle[version].location} onChange={this.updateMultiLevelSetting.bind(this, 'arrowStyle', version, 'location')}>
                        <option value="under">{this.props.strings.under}</option>
                        <option value="over">{this.props.strings.over}</option>
                    </select>
                </div>
                <div className="column column-25">
                    {this.props.strings.dashSize}
                    <Slider
                        min={0}
                        max={10}
                        step={1}
                        value={this.props.arrowStyle[version].dash}
                        orientation="horizontal"
                        onChange={this.updateMultiLevelSettingWithValue.bind(this, 'arrowStyle', version, 'dash')}
                    />
                </div>
                <div className="column column-25">
                    {this.props.strings.opacity}
                    <Slider
                        min={0}
                        max={10}
                        step={1}
                        value={this.props.arrowStyle[version].opacity}
                        orientation="horizontal"
                        onChange={this.updateMultiLevelSettingWithValue.bind(this, 'arrowStyle', version, 'opacity')}
                    />
                </div>
            </div>
            <div className="row">
                <div className="column column-20">
                    {this.props.strings.lineColor}
                    <ColorPicker
                        color={{hex: this.props.arrowStyle[version].lineColor}}
                        handleChange={this.handleMultiLevelColorChange.bind(this, 'arrowStyle', version, 'lineColor')}
                    />
                </div>
                <div className="column column-20">
                    {this.props.strings.headColor}
                    <ColorPicker
                        color={{hex: this.props.arrowStyle[version].headColor}}
                        handleChange={this.handleMultiLevelColorChange.bind(this, 'arrowStyle', version, 'headColor')}
                    />
                </div>
                <div className="column column-20">
                    {this.props.strings.headOutlineColor}
                    <ColorPicker
                        color={{hex: this.props.arrowStyle[version].headOutlineColor}}
                        handleChange={this.handleMultiLevelColorChange.bind(this, 'arrowStyle', version, 'headOutlineColor')}
                    />
                </div>
                <div className="column column-20">
                    {this.props.strings.lineSize}
                    <Slider
                        min={0}
                        max={10}
                        step={1}
                        value={this.props.arrowStyle[version].lineSize}
                        orientation="horizontal"
                        onChange={this.updateMultiLevelSettingWithValue.bind(this, 'arrowStyle', version, 'lineSize')}
                    />
                </div>
                <div className="column column-20">
                    {this.props.strings.headSize}
                    <Slider
                        min={0}
                        max={10}
                        step={1}
                        value={this.props.arrowStyle[version].headSize}
                        orientation="horizontal"
                        onChange={this.updateMultiLevelSettingWithValue.bind(this, 'arrowStyle', version, 'headSize')}
                    />
                </div>
            </div>
        </div>            
        )
    }

    wallSetting(version) {
        return (
        <div className="container" style={{padding: '0px'}}>
            <div className="row">
                <div className="column column-20">
                    {this.props.strings.color}
                    <ColorPicker
                        color={{hex: this.props.wallStyle[version].color}}
                        handleChange={this.handleMultiLevelColorChange.bind(this, 'wallStyle', version, 'color')}
                    />
                </div>
                <div className="column">
                    {this.props.strings.type}
                    <select value={this.props.wallStyle[version].style} onChange={this.updateMultiLevelSetting.bind(this, 'wallStyle', version, 'style')}>
                        <option value="solid">{this.props.strings.solid}</option>
                        <option value="dotted">{this.props.strings.dotted}</option>
                        <option value="dashed">{this.props.strings.dashed}</option>
                    </select>
                </div>
                <div className="column">
                    {this.props.strings.size}
                    <Slider
                        min={0}
                        max={5}
                        step={1}
                        value={this.props.wallStyle[version].size}
                        orientation="horizontal"
                        onChange={this.updateMultiLevelSettingWithValue.bind(this, 'wallStyle', version, 'size')}
                    />                                        
                </div>
            </div>
        </div>            
        )
    }

    layerSetting(version) {
        return (
            <div className="container" style={{padding: '0px'}}>
                <div className="row">
                    <div className="column column-20">
                        {this.props.strings.color}
                        <ColorPicker
                            color={{hex: this.props.layerStyle[version].backgroundColor}}
                            handleChange={this.handleMultiLevelColorChange.bind(this, 'layerStyle', version, 'backgroundColor')}
                        />
                    </div>
                    <div className="column column-25">
                        {this.props.strings.opacity}
                        <Slider
                            min={0}
                            max={1}
                            step={0.1}
                            value={this.props.layerStyle[version].opacity}
                            orientation="horizontal"
                            onChange={this.updateMultiLevelSettingWithValue.bind(this, 'layerStyle', version, 'opacity')}
                        />
                    </div>
                </div>
            </div>            
        )
    }

    indexSetting(version) {
        return (
            <div className="container" style={{padding: '0px'}}>
                <div className="row">
                    <div className="column column-20">
                        {this.props.strings.color}
                        <ColorPicker
                            color={{hex: this.props.indexStyle[version].color}}
                            handleChange={this.handleMultiLevelColorChange.bind(this, 'indexStyle', version, 'color')}
                        />
                    </div>                
                    <div className="column">
                        {this.props.strings.type}
                        <select value={this.props.indexStyle[version].type} onChange={this.updateMultiLevelSetting.bind(this, 'indexStyle', version, 'type')}>
                            <option value="square">{this.props.strings.square}</option>
                            <option value="circle">{this.props.strings.circle}</option>
                        </select>
                    </div>
                    <div className="column">
                        {this.props.strings.size}
                        <Slider
                            min={0}
                            max={10}
                            step={1}
                            value={this.props.indexStyle[version].size}
                            orientation="horizontal"
                            onChange={this.updateMultiLevelSettingWithValue.bind(this, 'indexStyle', version, 'size')}
                        />
                    </div>
                    <div className="column">
                        {this.props.strings.radius}
                        <Slider
                            min={0}
                            max={10}
                            step={1}
                            value={this.props.indexStyle[version].radius}
                            orientation="horizontal"
                            onChange={this.updateMultiLevelSettingWithValue.bind(this, 'indexStyle', version, 'radius')}
                        />
                    </div>
                </div>
            </div>            
        )
    }
}


// WEBPACK FOOTER //
// ./src/Settings.js